import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Directive, ElementRef, Input, Renderer2, OnChanges, SimpleChanges
} from '@angular/core';

import { SvgIconSizeMod } from 'models/layout-mod.model';
import { ThemeService } from 'shared/services/theme.service';

@Directive({
  selector: '[svgImage]'
})
export class SvgImageDirective implements OnChanges {
  @Input() image? = '';

  @Input() themeImage? = '';

  @Input() imageSize?: SvgIconSizeMod;

  parser: DOMParser = new DOMParser();

  svgWrapperElement!: HTMLElement;

  readonly insertedSVG = 'insertedSVG';

  defaultImageSize = SvgIconSizeMod.DEFAULT;

  constructor(
    private themeService: ThemeService,
    private http: HttpClient,
    private renderer: Renderer2,
    private elRef: ElementRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.svgWrapperElement) {
      this.svgWrapperElement = this.elRef.nativeElement;
    }

    if (changes.image && changes.image.currentValue) {
      this.loadSvg(`assets/common/icons/${changes.image.currentValue}.svg`);
    }
    if (changes.themeImage && changes.themeImage.currentValue) {
      this.themeService.getIconPath()
        .subscribe((path: string) => {
          this.loadSvg(`${path}${changes.themeImage.currentValue}.svg`);
        });
    }
  }

  loadSvg(val: string): void {
    const headers = new HttpHeaders({ Accept: 'image/svg+xml' });

    this.http.get(val, { headers, responseType: 'text' })
      .subscribe((res: any) => {
        const svg: Document = this.parser.parseFromString(res, 'image/svg+xml');
        const firstChild = this.svgWrapperElement.firstElementChild || null;

        if (
          this.imageSize
          || (!svg.documentElement.getAttribute('width') && !svg.documentElement.getAttribute('height'))
        ) {
          const imageSizeVal = (!this.imageSize ? this.defaultImageSize : this.imageSize);
          this.renderer.setAttribute(svg.documentElement, 'width', imageSizeVal);
          this.renderer.setAttribute(svg.documentElement, 'height', imageSizeVal);
        }

        this.renderer.setAttribute(svg.documentElement, this.insertedSVG, '');

        if (firstChild && firstChild.hasAttribute(this.insertedSVG)) {
          this.renderer.removeChild(this.svgWrapperElement, firstChild);
        }

        this.renderer.insertBefore(this.svgWrapperElement, svg.documentElement, this.svgWrapperElement.firstChild);
      }, (err) => { console.error(err); });
  }
}
